import { SCHEDULER_REQUEST } from "../actions/utilities";

const INITIAL_STATE = {
  gettingDataLoading: false,
  gettingDataSuccess: false,
  gettingDataFailure: false,
  gettingDataError: null,
  gettingDataList: [],
  addDataLoading: false,
  addDataSuccess: false,
  addDataFailure: false,
  addDataError: null,
  deleteDataLoading: false,
  deleteDataSuccess: false,
  deleteDataFailure: false,
  deleteDataError: null,
  projectLookup: [],
  userLookup: [],
  departmentLookup: [],
  teamLookup: [],
  taskDetailsLoading: false,
  taskDetailsSuccess: false,
  taskDetailsFailure: false,
  taskDetailsError: null,
  taskDetails: null
};

export const schedulerReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SCHEDULER_REQUEST.SCHEDULER_DATA_REQUEST:
      return {
        ...state,
        gettingDataLoading: true,
        gettingDataSuccess: false,
        gettingDataFailure: false,
        gettingDataError: null,
      };
    case SCHEDULER_REQUEST.SCHEDULER_DATA_SUCCESS:
      return {
        ...state,
        gettingDataLoading: false,
        gettingDataSuccess: true,
        gettingDataFailure: false,
        gettingDataError: null,
        gettingDataList: action.payload,
      };
    case SCHEDULER_REQUEST.SCHEDULER_DATA_FAILURE:
      return {
        ...state,
        gettingDataLoading: false,
        gettingDataSuccess: false,
        gettingDataFailure: true,
        gettingDataError: action.payload,
      };
    case SCHEDULER_REQUEST.ADD_SCHEDULER_EVENT_REQUEST:
      return {
        ...state,
        addDataLoading: true,
        addDataSuccess: false,
        addDataFailure: false,
        addDataError: null,
      };
    case SCHEDULER_REQUEST.ADD_SCHEDULER_EVENT_SUCCESS:
      var data = state.gettingDataList;
      data.resourceData.push(action.payload);
      return {
        ...state,
        addDataLoading: false,
        addDataSuccess: true,
        addDataFailure: false,
        addDataError: null,
        gettingDataList: data,
      };
    case SCHEDULER_REQUEST.ADD_SCHEDULER_EVENT_FAILURE:
      return {
        ...state,
        addDataLoading: false,
        addDataSuccess: false,
        addDataFailure: true,
        addDataError: action.payload,
      };
    case SCHEDULER_REQUEST.DELETE_SCHEDULER_EVENT_REQUEST:
      return {
        ...state,
        deleteDataLoading: true,
        deleteDataSuccess: false,
        deleteDataFailure: false,
        deleteDataError: null,
      };
    case SCHEDULER_REQUEST.DELETE_SCHEDULER_EVENT_SUCCESS:
      let list_ = state.gettingDataList;
      for (var i = 0; i < state.gettingDataList.resourceData.length; i++) {
        if (list_.resourceData[i].Id === action.payload) {
          list_.resourceData.splice(i, 1);
        }
      }
      return {
        ...state,
        deleteDataLoading: false,
        deleteDataSuccess: true,
        deleteDataFailure: false,
        deleteDataError: null,
        gettingDataList: list_,
      };
    case SCHEDULER_REQUEST.DELETE_SCHEDULER_EVENT_FAILURE:
      return {
        ...state,
        deleteDataLoading: false,
        deleteDataSuccess: false,
        deleteDataFailure: true,
        deleteDataError: action.payload,
      };
    case SCHEDULER_REQUEST.GET_DEPARTMENT_LOOKUP_SUCCESS:
      return {
        ...state,
        departmentLookup: action.payload,
      };
    case SCHEDULER_REQUEST.GET_PROJECT_LOOKUP_SUCCESS:
      return {
        ...state,
        projectLookup: action.payload,
      };
    case SCHEDULER_REQUEST.GET_TEAM_LOOKUP_SUCCESS:
      return {
        ...state,
        teamLookup: action.payload,
      };
    case SCHEDULER_REQUEST.GET_USER_LOOKUP_SUCCESS:
      return {
        ...state,
        userLookup: action.payload,
      };
      case SCHEDULER_REQUEST.GET_TASK_DETAILS_REQUEST:
        return {
          ...state,
          taskDetailsLoading: true,
          taskDetailsSuccess: false,
          taskDetailsFailure: false,
          taskDetailsError: null
        };
  
      case SCHEDULER_REQUEST.GET_TASK_DETAILS_SUCCESS:
        return {
          ...state,
          taskDetailsLoading: false,
          taskDetailsSuccess: true,
          taskDetailsFailure: false,
          taskDetailsError: null,
          taskDetails: action.payload
        };
  
      case SCHEDULER_REQUEST.GET_TASK_DETAILS_FAILURE:
        return {
          ...state,
          taskDetailsLoading: false,
          taskDetailsSuccess: false,
          taskDetailsFailure: true,
          taskDetailsError: action.payload,
          taskDetails: null
        };
    default:
      return state;
  }
};
